<div class="user-management-page">
  <div id="group-info-table" class="cam-table mic-table mt-4">
    <mat-card class="search-card">
      <form [formGroup]="form" class="filters flex flex-row justify-center items-start sm-flex-col gap-4 search user-management-filters">
        <mat-form-field class="search-by-user-group-name-input editable-field" subscriptSizing="dynamic">
          <mat-label>{{ translationService.translate('UserGroupFilterLabelText') }}</mat-label>
          <input
            matInput
            formControlName="groupName"
            placeholder="{{ translationService.translate('UserGroupPlaceholderText') }}"
            autocomplete="off"
          />
          <button id="search-icon-name" disabled mat-icon-button matSuffix>
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
        <div class="flex flex-row flex-1 gap-4 justify-end user-management-actions">
          <button
            id="reset-filters"
            (click)="resetFilters()"
            mat-flat-button
            color="accent"
            class="mic-btn-icon-left btn-clear"
            aria-label="reset filters"
          >
            <mat-icon role="img" aria-label="restart_alt">refresh</mat-icon>
            {{ translationService.translate('clearFiltersText') }}
          </button>
          <button
            id="create-user-group-button"
            (click)="populateCreateUserGroup()"
            mat-flat-button
            color="primary"
            class="mic-btn-icon-left btn-primary"
            aria-label="create user group"
          >
            <mat-icon role="img" aria-label="add_user_group_alt">add_circle_outline</mat-icon>
            {{ translationService.translate('addUserGroupText') }}
          </button>
        </div>
      </form>
    </mat-card>
    <div class="table-wrapper">
      <mic-table
        appCopyOnSelect
        #paginatedTable
        class="table-stripped"
        [config]="groupTableConfig"
        [fetcher]="groupFetcher"
        [filtersConfig]=""
      >
        <ng-container *micTableNoData>
          <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
        </ng-container>

        <ng-container *micTableColumnSelector class="space-between-button-container">
          <button id="table-column-selector" mat-flat-button class="column-button">
            <mat-icon>view_column</mat-icon>
            {{ translationService.translate('columnsButtonText') }}
          </button>
        </ng-container>

        <ng-container *micCellTemplate="let item; name: 'actionCell'">
          <button
            mat-icon-button
            (click)="onActionClick(item); $event.stopPropagation()"
            [attr.aria-label]="translationService.translate('deleteText')"
          >
            <mat-icon>delete_outline</mat-icon>
          </button>
        </ng-container>
      </mic-table>
    </div>

    <div class="mobile-group-cards" role="list" [attr.aria-label]="translationService.translate('groupsText')">
      @if (groups.length === 0) {
      <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      } @for (item of groups; track item.userGroupId) {
      <mat-card class="mobile-group-card" role="listitem">
        <div class="mobile-group-card-row">
          <span class="mobile-group-card-label">{{ translationService.translate('userGroupNameText') }}</span>
          <span class="mobile-group-card-value">{{ item.groupName }}</span>
        </div>
        <div class="mobile-group-card-row">
          <span class="mobile-group-card-label">{{ translationService.translate('descriptionText') }}</span>
          <span class="mobile-group-card-value">{{ item.description }}</span>
        </div>
        <div class="mobile-group-card-row">
          <span class="mobile-group-card-label">{{ translationService.translate('assignedToText') }}</span>
          <span class="mobile-group-card-value">{{ item.assignedTo }}</span>
        </div>
        <div class="mobile-group-card-row">
          <span class="mobile-group-card-label">{{ translationService.translate('updatedOnColumnText') }}</span>
          <span class="mobile-group-card-value">{{ item.lastUpdtTimestamp | date : 'yyyy-MM-dd' }}</span>
        </div>
        <div class="mobile-group-card-row">
          <span class="mobile-group-card-label">{{ translationService.translate('lastModifiedByText') }}</span>
          <span class="mobile-group-card-value">{{ item.lastModifiedBy }}</span>
        </div>
        <div class="mobile-group-card-actions">
          <button
            mat-flat-button
            type="button"
            class="btn-delete mobile-group-delete-text"
            (click)="onActionClick(item)"
            [attr.aria-label]="translationService.translate('deleteText')"
          >
            {{ translationService.translate('deleteText') }}
          </button>
        </div>
      </mat-card>
      }
    </div>
  </div>
</div>

<ng-template #deleteUserGroupModalWarning>Are you sure you want to delete {{ groupToDelete?.groupName }} </ng-template>
<mic-modal class="modalC" #deleteUserGroupModal (result)="onDeleteUserGroupModalClosed($event)"></mic-modal>
